(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-cart-drawer-cro"]) return;
  try {
    
  (() => {
    const enhanceCartDrawer = (root = document) => {
      const checkout = root.querySelector('cart-drawer .cart__checkout-button');
      if (checkout && checkout.textContent.trim() !== 'Checkout Securely') {
        checkout.textContent = 'Checkout Securely';
        checkout.setAttribute('aria-label', 'Checkout securely');
      }

      root.querySelectorAll('cart-drawer .te-cart-milestone__message').forEach((message) => {
        message.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Free Shipping')) {
            node.textContent = node.textContent.replace(/Free Shipping/g, 'Free Delivery');
          }
        });
      });
    };

    const initialize = () => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.dataset.teCroEnhanced === 'true') {
        enhanceCartDrawer();
        return;
      }

      drawer.dataset.teCroEnhanced = 'true';
      enhanceCartDrawer();

      const observer = new MutationObserver(() => enhanceCartDrawer());
      observer.observe(drawer, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('cart:updated', initialize);
    document.addEventListener('cart:refresh', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-mobile-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sticky = document.querySelector('[data-te-mobile-sticky-buy]');
    const productPage = document.querySelector('product-info.te-product-page');
    if (!sticky || !productPage || sticky.dataset.initialized === 'true') return;

    sticky.dataset.initialized = 'true';

    const stickyButton = sticky.querySelector('[data-te-sticky-submit]');
    const stickyLabel = sticky.querySelector('[data-te-sticky-label]');
    const stickyPrice = sticky.querySelector('[data-te-sticky-price]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let primaryButton = null;
    let priceContainer = null;
    let passedPrimaryButton = false;

    const getPrimaryButton = () => productPage.querySelector('.product-form__submit');
    const getPriceContainer = () => productPage.querySelector('[id^="price-"]');

    const visiblePriceText = () => {
      const price = getPriceContainer();
      if (!price) return '';

      const salePrice = price.querySelector('.price--on-sale .price-item--sale, .price__sale .price-item--sale');
      const regularPrice = price.querySelector('.price__regular .price-item--regular, .price-item--regular');
      const source = salePrice || regularPrice;
      return source ? source.textContent.trim() : '';
    };

    const syncState = () => {
      primaryButton = getPrimaryButton();
      priceContainer = getPriceContainer();
      if (!primaryButton || !stickyButton) return;

      const disabled = primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;

      if (stickyLabel) {
        const primaryLabel = primaryButton.querySelector('span:not(.loading__spinner)');
        const label = primaryLabel ? primaryLabel.textContent.replace(/\s+/g, ' ').trim() : '';
        stickyLabel.textContent = label || (disabled ? 'Sold Out' : 'Add to Cart');
      }

      if (stickyPrice) {
        const priceText = visiblePriceText();
        if (priceText) stickyPrice.textContent = priceText;
      }
    };

    const updateVisibility = () => {
      primaryButton = getPrimaryButton();
      if (!primaryButton || !mobileQuery.matches) {
        sticky.hidden = true;
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
        return;
      }

      const rect = primaryButton.getBoundingClientRect();
      passedPrimaryButton = rect.bottom < 0;
      const cartOpen = document.documentElement.classList.contains('te-cart-drawer-open');
      const shouldShow = passedPrimaryButton && !cartOpen;

      sticky.hidden = false;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    stickyButton?.addEventListener('click', () => {
      primaryButton = getPrimaryButton();
      if (!primaryButton || primaryButton.disabled) return;
      sticky.classList.remove('is-visible');
      primaryButton.click();
    });

    const productObserver = new MutationObserver(() => {
      syncState();
      updateVisibility();
    });

    productObserver.observe(productPage, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    const htmlObserver = new MutationObserver(updateVisibility);
    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    mobileQuery.addEventListener?.('change', updateVisibility);

    syncState();
    updateVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-predictive-search-controller"]) return;
  try {
    
  (() => {
    const controller = document.querySelector('[data-te-predictive-search-controller]');
    if (!controller || controller.dataset.initialized === 'true') return;

    controller.dataset.initialized = 'true';

    const predictiveUrl = controller.dataset.predictiveUrl;
    const sectionId = controller.dataset.sectionId;
    const loadingText = controller.dataset.loadingText || 'Loading';
    const suggestionsLabel = controller.dataset.suggestionsLabel || 'Search suggestions';
    const cache = new Map();
    const cacheLimit = 20;
    const selectors = ['.te-search', '.te-search-drawer-form', '.te-mobile-search'];

    const normalizeTerm = (term) => term.trim().toLocaleLowerCase();

    const cacheSet = (key, value) => {
      if (cache.has(key)) cache.delete(key);
      cache.set(key, value);
      if (cache.size > cacheLimit) cache.delete(cache.keys().next().value);
    };

    const initializeForm = (form, index) => {
      if (!form || form.dataset.tePredictiveInitialized === 'true') return;

      const input = form.querySelector('input[type="search"][name="q"]');
      if (!input) return;

      form.dataset.tePredictiveInitialized = 'true';
      form.classList.add('te-predictive-search-form');

      const host = document.createElement('div');
      host.className = 'te-predictive-search-host';
      form.parentNode.insertBefore(host, form);
      host.appendChild(form);

      const panel = document.createElement('div');
      panel.className = 'te-predictive-search-panel';
      panel.id = `TePredictiveSearch-${index}`;
      panel.hidden = true;
      panel.setAttribute('role', 'listbox');
      panel.setAttribute('aria-label', suggestionsLabel);
      panel.setAttribute('aria-busy', 'false');
      host.appendChild(panel);

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-haspopup', 'listbox');
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('spellcheck', 'false');

      let debounceTimer = null;
      let requestController = null;
      let activeIndex = -1;
      let currentTerm = '';
      let allowOpen = false;

      const options = () => Array.from(panel.querySelectorAll('[data-te-predictive-option]'));

      const prepareOptions = () => {
        options().forEach((option, optionIndex) => {
          if (!option.id) option.id = `${panel.id}-Option-${optionIndex}`;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
        });
      };

      const setExpanded = (expanded) => {
        panel.hidden = !expanded;
        input.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (!expanded) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
          options().forEach((option) => {
            option.removeAttribute('data-active');
            option.setAttribute('aria-selected', 'false');
          });
        }
      };

      const close = ({ abort = false, dismiss = false } = {}) => {
        window.clearTimeout(debounceTimer);
        if (dismiss) allowOpen = false;

        if (abort && requestController) {
          requestController.abort();
          requestController = null;
        }

        panel.setAttribute('aria-busy', 'false');
        setExpanded(false);
      };

      const setActive = (nextIndex) => {
        const items = options();
        if (!items.length) return;

        activeIndex = (nextIndex + items.length) % items.length;

        items.forEach((item, itemIndex) => {
          const active = itemIndex === activeIndex;
          item.toggleAttribute('data-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');

          if (active) {
            input.setAttribute('aria-activedescendant', item.id);
            item.scrollIntoView({ block: 'nearest' });
          }
        });
      };

      const render = (html, term) => {
        if (!allowOpen || normalizeTerm(input.value) !== normalizeTerm(term)) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector(`#shopify-section-${sectionId}`);

        panel.innerHTML = section ? section.innerHTML : '';
        panel.setAttribute('aria-busy', 'false');
        currentTerm = normalizeTerm(term);
        activeIndex = -1;
        prepareOptions();
        setExpanded(Boolean(panel.textContent.trim()));
      };

      const fetchResults = async (term) => {
        const cacheKey = normalizeTerm(term);
        if (!cacheKey || !allowOpen) return;

        if (cache.has(cacheKey)) {
          render(cache.get(cacheKey), term);
          return;
        }

        if (requestController) requestController.abort();

        const activeRequest = new AbortController();
        requestController = activeRequest;
        panel.innerHTML = `<p class="te-predictive-search-panel__loading" role="status" aria-live="polite">${loadingText}</p>`;
        panel.setAttribute('aria-busy', 'true');
        setExpanded(true);

        const params = new URLSearchParams();
        params.set('q', term);
        params.set('resources[type]', 'product,collection,query');
        params.set('resources[limit]', '6');
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('section_id', sectionId);

        try {
          const response = await fetch(`${predictiveUrl}?${params.toString()}`, {
            signal: activeRequest.signal,
            headers: { Accept: 'text/html' }
          });

          if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

          const html = await response.text();
          cacheSet(cacheKey, html);
          render(html, term);
        } catch (error) {
          if (error.name !== 'AbortError') close();
        } finally {
          if (requestController === activeRequest) requestController = null;
        }
      };

      const scheduleSearch = () => {
        window.clearTimeout(debounceTimer);
        const term = input.value.trim();
        allowOpen = true;

        if (term.length < 2) {
          currentTerm = '';
          close({ abort: true });
          return;
        }

        debounceTimer = window.setTimeout(() => fetchResults(term), 180);
      };

      input.addEventListener('input', scheduleSearch);
      input.addEventListener('focus', () => {
        allowOpen = true;
        const term = input.value.trim();
        if (term.length < 2) return;

        if (normalizeTerm(term) === currentTerm && panel.textContent.trim()) {
          setExpanded(true);
        } else {
          scheduleSearch();
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          if (panel.hidden) {
            scheduleSearch();
          } else {
            event.preventDefault();
            setActive(activeIndex + 1);
          }
        } else if (event.key === 'ArrowUp' && !panel.hidden) {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0 && !panel.hidden) {
          const item = options()[activeIndex];
          if (item) {
            event.preventDefault();
            item.click();
          }
        } else if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          event.stopPropagation();
          close({ abort: true, dismiss: true });
        }
      });

      form.addEventListener('submit', () => close({ abort: true, dismiss: true }));

      document.addEventListener('pointerdown', (event) => {
        if (!host.contains(event.target)) close({ abort: true, dismiss: true });
      });
    };

    const initialize = () => {
      let index = 0;

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((form) => {
          initializeForm(form, index);
          index += 1;
        });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('te-related-products')) {
    customElements.define(
      'te-related-products',
      class TeRelatedProducts extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true') {
            this.initializeSlider();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;

              this.observer.disconnect();
              this.loadRecommendations();
            },
            { rootMargin: '0px 0px 300px 0px' }
          );

          this.observer.observe(this);
        }

        loadRecommendations() {
          fetch(this.dataset.url)
            .then((response) => {
              if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
              return response.text();
            })
            .then((text) => {
              const documentFragment = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = documentFragment.querySelector('te-related-products');

              if (!recommendations || !recommendations.innerHTML.trim()) return;

              this.innerHTML = recommendations.innerHTML;
              this.dataset.loaded = 'true';
              this.dataset.sliderReady = 'false';
              this.initializeSlider();
            })
            .catch((error) => console.error(error));
        }

        initializeSlider() {
          if (this.dataset.sliderReady === 'true') return;

          const track = this.querySelector('[data-te-related-track]');
          const previous = this.querySelector('[data-te-related-previous]');
          const next = this.querySelector('[data-te-related-next]');

          if (!track) return;

          this.dataset.sliderReady = 'true';

          const getScrollAmount = () => {
            const item = track.querySelector('.te-related-products__item');
            const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
            return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          };

          const updateArrows = () => {
            if (!previous || !next) return;

            const maxScroll = track.scrollWidth - track.clientWidth - 2;

            if (maxScroll <= 0) {
              previous.setAttribute('disabled', 'disabled');
              next.setAttribute('disabled', 'disabled');
              return;
            }

            if (track.scrollLeft <= 2) {
              previous.setAttribute('disabled', 'disabled');
            } else {
              previous.removeAttribute('disabled');
            }

            if (track.scrollLeft >= maxScroll) {
              next.setAttribute('disabled', 'disabled');
            } else {
              next.removeAttribute('disabled');
            }
          };

          previous?.addEventListener('click', () => {
            track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
            window.setTimeout(updateArrows, 450);
          });

          next?.addEventListener('click', () => {
            track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            window.setTimeout(updateArrows, 450);
          });

          let isMouseDown = false;
          let startX = 0;
          let startScrollLeft = 0;
          let moved = false;

          track.addEventListener('dragstart', (event) => {
            event.preventDefault();
          });

          track.addEventListener('mousedown', (event) => {
            if (event.button !== 0) return;
            if (event.target.closest('button, input, select, textarea')) return;

            isMouseDown = true;
            moved = false;
            startX = event.pageX;
            startScrollLeft = track.scrollLeft;

            track.classList.add('is-dragging');
          });

          window.addEventListener('mousemove', (event) => {
            if (!isMouseDown) return;

            const distance = event.pageX - startX;

            if (Math.abs(distance) > 3) {
              moved = true;
              event.preventDefault();
              track.scrollLeft = startScrollLeft - distance;
            }
          });

          window.addEventListener('mouseup', () => {
            if (!isMouseDown) return;

            isMouseDown = false;
            track.classList.remove('is-dragging');

            window.setTimeout(() => {
              moved = false;
            }, 100);

            updateArrows();
          });

          track.addEventListener(
            'click',
            (event) => {
              if (moved) {
                event.preventDefault();
                event.stopPropagation();
              }
            },
            true
          );

          track.addEventListener('scroll', () => {
            window.requestAnimationFrame(updateArrows);
          });

          window.addEventListener('resize', updateArrows);

          updateArrows();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
